import { SelectOption } from 'global';
import { useState } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete, TextField, CircularProgress } from '@mui/material';

interface AsyncAutocompleteFieldProps {
  name: string;
  control: any;
  label?: string;
  multiple?: boolean;
  extraAction?: (nextValue: SelectOption[]) => void;
  fetchOptions: (query: string) => Promise<SelectOption[]>;
}

export const AsyncAutocompleteField = ({
  name,
  label,
  control,
  extraAction,
  fetchOptions,
  multiple = false,
}: AsyncAutocompleteFieldProps) => {
  const [options, setOptions] = useState<SelectOption[]>([]);
  const [loading, setLoading] = useState(false);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          {...field}
          options={options}
          loading={loading}
          multiple={multiple}
          getOptionLabel={o => o.label}
          isOptionEqualToValue={(o, v) => o.value === v.value}
          onInputChange={(_, val) => {
            if (val.length > 2 || loading) {
              setLoading(true);

              fetchOptions(val)
                .then(setOptions)
                .finally(() => {
                  setLoading(false);
                });
            }
          }}
          onChange={(_, val) => {
            field.onChange(val);

            if (typeof extraAction === 'function') {
              extraAction(val);
            }
          }}
          renderInput={params => (
            <TextField
              {...params}
              label={label}
              size="small"
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? <CircularProgress size={18} /> : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      )}
    />
  );
};
